import { render, staticRenderFns } from "./SlidePagination.vue?vue&type=template&id=0e67d8bd&scoped=true&"
import script from "./SlidePagination.vue?vue&type=script&lang=js&"
export * from "./SlidePagination.vue?vue&type=script&lang=js&"
import style0 from "./SlidePagination.vue?vue&type=style&index=0&id=0e67d8bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e67d8bd",
  null
  
)

export default component.exports